<template>
  <div />
</template>

<script>
export default {
  name: 'PhotosDetail',
}
</script>

<style scoped>

</style>
